import React from "react";
import DatePickerInner from './DatePickerInner';

export default class WaitDialogFileDownload extends React.Component {

    render (){

        return ( 

        <div style={{display: this.props.show == true ? 'block' : 'none'}}> 
            <div style={mainClass}>
        <div style={message} >{this.props.ready ? <div onClick={() => {
                window.open(this.props.file, '_blank');
                this.props.onClose();
            }}>Clicca qui per scaricare il file</div> : 'Attendere...'}</div>
            </div>
        </div>
        )
    }
}

const mainClass = {
    position: 'fixed',
    top: '25%',
    left: '25%', 
    width: '50%',
    height: '50%',
    border: '1px solid black',
    background: '#ffffff'
}

const message = {
    textAlign: 'center',
    top: '45%',
    position: 'relative',
    cursor: 'pointer'
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}